

















































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import SpFieldMap from '@/app/components/SpField/SpFieldMap.vue'
import SpFieldImg from '@/app/components/SpField/SpFieldImg.vue'
import SpHeader from '@/app/components/Common/SpHeader.vue'
import FieldListApi from '@/app/model/api/fieldListApi'
/* module */
import SelectClass from '@/app/module/select'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import DateClass from '@/app/module/date'

@Component({
  components: {
    Loading,
    SpFieldMap,
    SpFieldImg,
    SpHeader
  }
})
export default class Field extends Vue {
  /* データ */
  private fieldData: Array<{[key:string]: string|number}> = []
  public mapData: Array<{[key:string]: any}> = []
  private mapList: Array<{[key:string]: any}> = []
  private searchData: any = {
    word: this.$store.state.spFieldState.searchText,
    order_num: this.$store.state.spFieldState.orderName,
    variety_id: this.$store.state.spFieldState.varietyId,
    grade_id: this.$store.state.spFieldState.gradeId,
    growth_stage_id: this.$store.state.spFieldState.stageId,
    risk_id: this.$store.state.spFieldState.riskId,
    is_field: this.$store.state.spFieldState.fieldType
  }
  private errorMessage: string = ''
  private selectedField: number = 0
  private latitude = 0
  private longitude = 0
  private presentLatLng: any = {
    lat: null,
    lng: null
  }
  private sortOrderList: {text: string, value: number}[] = SelectClass.sortOrderList
  private sortFieldList: {text: string, value: number}[] = SelectClass.sortFieldList
  // 検索項目
  private statusList: string[] = []
  private varietyList: string[] = []
  private gradeList: Array<{[key:string]: string|number}> = []
  private riskList: string[] = []
  /* 表示切り替え */
  private isActive: boolean = false
  private showNotFound: boolean = false
  private showNotFoundLatLng: boolean = false
  private showLoading: boolean = true
  private showSearch: boolean = false

  private viewHeight:number = 100

  private get spFieldChoiceState (): string {
    return this.$store.state.spFieldState.choiceFieldId
  }
  @Watch('spFieldChoiceState')
  onSpIdChange (newValue: string) {
    this.scrollChoiceField()
  }

  private scrollChoiceField () {
    const fieldId = this.$store.state.spFieldState.choiceFieldId
    this.selectedField = parseInt(fieldId)
    let el: any = document.getElementById(fieldId)

    if (el && this.$store.state.fieldChoiceState.isScroll) {
      el.scrollIntoView({ behavior: 'instant' })
    } else {
      this.$store.commit('fieldChoiceState/setIsScroll', true)
    }
  }

  mounted () {
    this.viewHeight = window.innerHeight
    if (this.searchData.order_num === 1) {
      this.getCurrentLatLng()
    } else {
      this.showNotFoundLatLng = false
      this.getFieldData()
    }
  }

  destroyed () {
    this.$store.commit('fieldChoiceState/setIsScroll', true)
  }

  private getCurrentLatLng () {
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 0
    }
    navigator.geolocation.getCurrentPosition(this.success, this.error, options)
  }

  private success (position: any) {
    this.latitude = position.coords.latitude
    this.longitude = position.coords.longitude
    this.presentLatLng = {
      lat: this.latitude,
      lng: this.longitude
    }
    this.showNotFoundLatLng = false
    this.getFieldData()
  }

  private error () {
    this.showLoading = false
    this.showNotFoundLatLng = true
    this.mapData = []
    this.presentLatLng = {
      lat: null,
      lng: null
    }
    this.getFieldData()
  }

  private changeList (fieldId: number) {
    this.$store.commit('fieldChoiceState/setIsScroll', false)
    this.$store.commit('spFieldState/setChoiceField', fieldId)
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-'
  }

  private displayPlantingType (type: any) {
    return CommonClass.displayPlantingType(type)
  }

  private displayValue (value: string) {
    if (value === null || value === undefined || value === '') {
      return '-'
    } else {
      return value
    }
  }

  /* データ取得 */
  private async getFieldData () {
    this.showLoading = true
    this.showNotFound = false

    /* ページの一番上を表示 */
    this.isActive = true
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    const data = {
      word: this.$store.state.spFieldState.searchText,
      order_num: this.$store.state.spFieldState.orderName,
      field_point_lng: this.longitude,
      field_point_lat: this.latitude,
      variety_id: this.$store.state.spFieldState.varietyId,
      grade_id: this.$store.state.spFieldState.gradeId,
      growth_stage_id: this.$store.state.spFieldState.stageId,
      risk_id: this.$store.state.spFieldState.riskId,
      is_polygon: 1,
      is_field: this.$store.state.spFieldState.fieldType
    }

    const result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly, '1', data)

    if (result.isOk()) {
      this.varietyList = result.getPayload().varieties
      this.statusList = result.getPayload().growth_stage
      this.gradeList = result.getPayload().grade
      this.riskList = result.getPayload().risk

      if (this.showNotFoundLatLng) {
        this.mapCreate()
      } else {
        this.fieldData = result.getPayload().field_list

        /* マップのデータを作成 */
        if (result.getPayload().polygon_list.length !== 0) {
          /* マップデータ作成 */
          for (var j in result.getPayload().polygon_list) {
            this.createDataList(result.getPayload().polygon_list[j], parseInt(j))
          }
          this.mapCreate()
          this.mapData = this.mapList
          this.isActive = false
        } else {
          this.mapCreate()
          this.showNotFound = true
        }

        if (this.$store.state.spFieldState.choiceFieldId !== 0) {
          setTimeout(this.scrollChoiceField, 200)
        }
      }
      this.showLoading = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'alert')
    }
  }

  /* 取得したデータからリストを作成 */
  private createDataList (result: any, key: number) {
    /* マップのデータを作成 */
    const mapData: any = {
      id: result.polygon_field_id,
      path: result.polygon,
      strokeColor: result.polygon_color,
      fillColor: result.polygon_frame_color,
      fieldCamSensor1: null,
      fieldCamSensor2: null,
      fieldServerSensor: null,
      paddyWatchSensor: null
    }

    // fieldcamだけ、配列
    if (result.field_cam_sensor !== null && result.field_cam_sensor.length !== 0) {
      for (const i in result.field_cam_sensor) {
        if (result.field_cam_sensor[i].display_number === 1) {
          mapData['fieldCamSensor1'] = {
            lat: result.field_cam_sensor[i].field_cam_sensor_lat,
            lng: result.field_cam_sensor[i].field_cam_sensor_lng
          }
        }
        if (result.field_cam_sensor[i].display_number === 2) {
          mapData['fieldCamSensor2'] = {
            lat: result.field_cam_sensor[i].field_cam_sensor_lat,
            lng: result.field_cam_sensor[i].field_cam_sensor_lng
          }
        }
      }
    }

    if (result.field_server_sensor !== null) {
      mapData['fieldServerSensor'] = {
        lat: result.field_server_sensor.field_server_sensor_lat,
        lng: result.field_server_sensor.field_server_sensor_lng
      }
    }

    if (result.paddy_watch_sensor !== null) {
      mapData['paddyWatchSensor'] = {
        lat: result.paddy_watch_sensor.paddy_watch_sensor_lat,
        lng: result.paddy_watch_sensor.paddy_watch_sensor_lng
      }
    }

    if (result.polygon.length === 0) {
      mapData.fieldPosition = {
        lat: parseFloat(result.field_lat),
        lng: parseFloat(result.field_lng)
      }
    }

    this.mapList[key] = mapData
  }

  /* ポリゴン表示 */
  private mapCreate () {
    if (this.searchData.order_num === 1) {
      this.$store.commit('mapState/setBaseData', this.presentLatLng)
    } else {
      if (this.mapList.length !== 0) {
        /* リストの一番上のデータをマップの中心にする */
        if (Session.getChoiceFieldId()! === null) {
          if (this.mapList[0].path !== undefined && Object.keys(this.mapList[0].path).length !== 0) {
            if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
              this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
            } else {
              this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
            }
          } else {
            let lat
            let lng
            if (this.mapList[0].fieldPosition.lat !== undefined) {
              lat = this.mapList[0].fieldPosition.lat
              lng = this.mapList[0].fieldPosition.lng
            } else {
              lat = this.mapList[0].field_lat
              lng = this.mapList[0].field_lng
            }

            this.$store.commit('mapState/setBaseData', {
              lat: parseFloat(lat),
              lng: parseFloat(lng)
            })
          }
        } else {
          if (this.mapList[0].path !== undefined || this.mapData[0].path.length !== 0) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            let lat
            let lng
            if (this.mapList[0].fieldPosition.lat !== undefined) {
              lat = this.mapList[0].fieldPosition.lat
              lng = this.mapList[0].fieldPosition.lng
            } else {
              lat = this.mapList[0].field_lat
              lng = this.mapList[0].field_lng
            }

            this.$store.commit('mapState/setBaseData', {
              lat: parseFloat(lat),
              lng: parseFloat(lng)
            })
          }
        }
      }
    }
  }

  /* 検索 */
  private async doSearch () {
    this.$store.commit('spFieldState/setSearchText', this.searchData.word)
    this.$store.commit('spFieldState/setOrderName', this.searchData.order_num)
    this.$store.commit('spFieldState/setFieldType', this.searchData.is_field)
    this.$store.commit('spFieldState/setVarietyId', this.searchData.variety_id)
    this.$store.commit('spFieldState/setGradeId', this.searchData.grade_id)
    this.$store.commit('spFieldState/setStageId', this.searchData.growth_stage_id)
    this.$store.commit('spFieldState/setRiskId', this.searchData.risk_id)
    this.$store.commit('spFieldState/setChoiceField', 0)
    this.showSearch = false
    this.mapData = []
    this.fieldData = []

    if (this.searchData.order_num === 1) {
      this.getCurrentLatLng()
    } else {
      this.showNotFoundLatLng = false
      this.getFieldData()
    }
  }

  private resetSearch () {
    this.searchData = {
      word: '',
      order_num: 1,
      variety_id: 0,
      grade_id: 0,
      growth_stage_id: 0,
      risk_id: 0,
      is_field: 0
    }
    this.$store.commit('spFieldState/setSearchText', this.searchData.word)
    this.$store.commit('spFieldState/setOrderName', this.searchData.order_num)
    this.$store.commit('spFieldState/setFieldType', this.searchData.variety_id)
    this.$store.commit('spFieldState/setVarietyId', this.searchData.grade_id)
    this.$store.commit('spFieldState/setGradeId', this.searchData.growth_stage_id)
    this.$store.commit('spFieldState/setStageId', this.searchData.risk_id)
    this.$store.commit('spFieldState/setRiskId', this.searchData.is_field)

    this.showSearch = false
    this.mapData = []
    this.getCurrentLatLng()
  }

  private displayHarvestLimit (limitDay: number) {
    return DateClass.displayHarvestLimit(limitDay)
  }

  private displayHarvestLimitDay (limitDay: number) {
    return DateClass.displayHarvestLimitDay(limitDay)
  }

  private displayHarvestDay (limitDay: number, date: string) {
    return DateClass.displayHarvestDay(limitDay, date)
  }
}
